import config from "../config";

export const validateMeetingId = async (meetingId) => {
  if (!meetingId) return false;

  try {
    const response = await fetch(`${config.baseUrl}/meetings/${meetingId}/validate`);
    const data = await response.json();

    return data.isValid;
  } catch (error) {
    console.error('Error validating meeting ID:', error);
    return false;
  }
};
